var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FFEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14C19.55 14 20 14.45 20 15V19C20 19.55 19.55 20 19 20C18.45 20 18 19.55 18 19V15C18 14.45 18.45 14 19 14ZM18.99 9C13.47 9 9 13.48 9 19C9 24.52 13.47 29 18.99 29C24.52 29 29 24.52 29 19C29 13.48 24.52 9 18.99 9ZM19 27C14.58 27 11 23.42 11 19C11 14.58 14.58 11 19 11C23.42 11 27 14.58 27 19C27 23.42 23.42 27 19 27ZM20 24H18V22H20V24Z",
    fill: "#AD1F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toast_error.37118bcdc8457b8a922b0660dc3842da.svg";
export { ForwardRef as ReactComponent };